// extracted by mini-css-extract-plugin
export var emailBlockLink = "_fy-0";